import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";
import { HttpResponse } from "@aws-amplify/core/internals/aws-client-utils";

@Injectable({
  providedIn: "root",
})
export class CoeAllocationService {
  constructor(private http: HttpUtilService) {}

  GetCategoryList(): Observable<any> {
    return this.http.get("COEAllocationService.asmx/GetCategoryList");
  }

  CheckCategory(bidDate: string, code: string): Observable<any> {
    const encodedCode = encodeURIComponent(`"${code}"`);
    const encodedBidDate = encodeURIComponent(bidDate);
    return this.http.get(
      `COEAllocationService.asmx/CheckCategory?bidDate=${encodedBidDate}&code=${encodedCode}`,
    );
  }

  OnContractChange(
    BidType: string,
    CoeBidDate: string,
    CoeCategory: string,
    CoeDepositAmount: string,
    CoeExipryDate: string,
    ContractNo: string,
  ): Observable<any> {
    return this.http.post(
      "COEAllocationService.asmx/OnContractChange",
      {
        model: {
          BidType,
          CoeBidDate,
          CoeCategory,
          CoeDepositAmount,
          CoeExipryDate,
          ContractNo,
        },
      },
    );
  }

  OnNricChange(
    BidType: string,
    CoeBidDate: string,
    CoeCategory: string,
    CoeDepositAmount: string,
    CoeExipryDate: string,
    ContractName: string,
    ContractNo: string,
    Nric: string,
  ): Observable<any> {
    return this.http.post("COEAllocationService.asmx/OnNricChange", {
      model: {
        BidType,
        CoeBidDate,
        CoeCategory,
        CoeDepositAmount,
        CoeExipryDate,
        ContractName,
        ContractNo,
        Nric,
      },
    });
  }

  OnCertificateNoChange(
    BidType: string,
    CoeBidDate: string,
    CoeCategory: string,
    CoeCertificateNo: string,
    CoeDepositAmount: string,
    CoeExipryDate: string,
    ContractName: string,
    ContractNo: string,
    Nric: string,
  ): Observable<any> {
    return this.http.post(
      "COEAllocationService.asmx/OnCertificateNoChange",
      {
        model: {
          BidType,
          CoeBidDate,
          CoeCategory,
          CoeCertificateNo,
          CoeDepositAmount,
          CoeExipryDate,
          ContractName,
          ContractNo,
          Nric,
        },
      },
    );
  }

  /* UploadFiles(
    file: ArrayBuffer,
    fileName: string,
    coeBidDate: string,
  ): Observable<any> {
    // Crear el FormData, pero enviar el archivo como File
    const formData = new FormData();

    // Convertir el ArrayBuffer a Blob y luego a un File
    const blob = new Blob([file], {
      type: "application/octet-stream",
    });

    // Aquí agregamos el archivo al FormData, que es lo que realmente esperamos enviar
    const fileToSend = new File([blob], fileName, {
      type: blob.type,
    });

    // Agregar los campos adicionales al FormData
    formData.append("docType", "CoeBiddingResults");
    formData.append("coeBidDate", coeBidDate);
    formData.append("file", fileToSend); // Ahora estamos pasando un File

    console.log("Sending fileData:", formData);

    return this.http
      .postFile("UploadFiles.ashx", formData)
      .pipe(
        map((response) => {
          console.log("Upload response:", response);
          return response;
        }),
        catchError((error) => {
          console.error("Upload error:", error);
          return throwError(() => new Error("File upload failed"));
        }),
      );
  } */
}
